function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "News"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-_x2F_-News-Detail",
  transform: "translate(-158.000000, -236.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(152.000000, 224.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-_x2F_-3-_x2F_-Arrow",
  transform: "translate(20.000000, 20.000000) scale(-1, 1) translate(-20.000000, -20.000000) "
}, /*#__PURE__*/React.createElement("polygon", {
  points: "25.8,12 24.6,13.2 30.8,19.6 7,19.6 7,21.4 30.7,21.4 24.5,27.8 25.7,29 34,20.5  "
})))));

var SvgGoback = function SvgGoback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 17",
    style: {
      enableBackground: "new 0 0 27 17"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/goback.1f999fac.svg";
export { ForwardRef as ReactComponent };